import { Heading } from "@ubnt/ui-components/aria";
import { CheckmarkIcon } from "@ubnt/icons";
import { ApproveButtonSection, Description, MainWrapper } from "./styles";
import { Button, designToken } from "@ubnt/ui-components";
import { app } from "../config/config";

type ActivateSuccessProps = {
  deviceName: string | null;
  onLoginAnotherDevice: () => void;
};

export const ActivateSuccess: React.FC<ActivateSuccessProps> = ({
  deviceName,
  onLoginAnotherDevice,
}) => {
  return (
    <MainWrapper>
      <Heading>Successful Login</Heading>
      <Description>Login by: {deviceName || "unknown device"}</Description>
      <CheckmarkIcon
        size={40}
        variant="fill"
        color={designToken["desktop-color-green-06-light"]}
      />
      <ApproveButtonSection>
        <Button
          onClick={() => (window.location.href = app.accountUrl)}
          variant="primary"
        >
          Go To Your Account
        </Button>
        <Button onClick={onLoginAnotherDevice} variant="tertiary">
          Login Another Device
        </Button>
      </ApproveButtonSection>
    </MainWrapper>
  );
};
